import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core';

import { TiimeButtonModule, TiimeTooltipModule } from 'tiime-material';

import { AppsAccessService } from '@services/apps-access.service';

@Component({
  selector: 'app-apps-access-button',
  standalone: true,
  imports: [TiimeButtonModule, TiimeTooltipModule],
  templateUrl: './apps-access-button.component.html',
  styleUrls: ['./apps-access-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppsAccessButtonComponent {
  @Input({ required: true }) companyId: number;
  @Input({ transform: booleanAttribute }) large = false;

  readonly icon = '/assets/icon-menu-sprite.svg#app-access';

  constructor(private readonly appsAccessService: AppsAccessService) {}

  openApps(): void {
    this.appsAccessService.openApps(this.companyId);
  }
}
